import { Button } from "antd";
import styles from "components/molecules/Alert/alert.module.css";

type AlertProps = {
	title?: string;
	subTitle?: string;
	showButton?: boolean;
	onClick?: () => void;
	buttonLabel?: string;
	info?: Array<string>;
};

const Alert = ({ title, subTitle, showButton, info, buttonLabel, onClick }: AlertProps) => {
	return (
		<div className={styles?.root}>
			<div className={styles?.bottom_ellipse_wrapper}>
				<div className={styles?.bottom_ellipse}>
					<svg width="69" height="53" viewBox="0 0 69 53" fill="none" xmlns="http://www.w3.org/2000/svg">
						<ellipse cx="-25.6761" cy="93.6129" rx="94.3239" ry="93.6129" fill="#EE362E" fillOpacity="0.7" />
					</svg>
				</div>
				<div className={styles?.top_ellipse}>
					<svg width="85" height="51" viewBox="0 0 85 51" fill="none" xmlns="http://www.w3.org/2000/svg">
						<ellipse cx="94.3239" cy="-39.5" rx="94.3239" ry="90.5" fill="#F58029" fillOpacity="0.8" />
					</svg>
				</div>
				<div className={styles?.top_right_ellipse}>
					<svg width="46" height="177" viewBox="0 0 46 177" fill="none" xmlns="http://www.w3.org/2000/svg">
						<ellipse cx="111.648" cy="70.5" rx="111" ry="106.5" fill="#63267B" fillOpacity="0.6" />
					</svg>
				</div>
				<div className={styles?.login_wrapper_success}>
					<div className={styles?.form_wrapper}>
						{showButton && (
							<div className={styles?.button_wrapper}>
								<Button className={styles?.button} onClick={onClick}>
									{buttonLabel}
								</Button>
							</div>
						)}
						{info && (
							<>
								{info?.map((item, idx) => {
									return (
										<div key={idx} className={styles?.info}>
											{item}
										</div>
									);
								})}
							</>
						)}
						{subTitle && <div className={styles?.sub_title}>{subTitle}</div>}
						{title && <div className={styles?.title}>{title}</div>}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Alert;
